import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { KieneUtils } from '../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import { Material } from '../material/material';
import { AddSupplierMaterialComponent } from './add-supplier-material/add-supplier-material.component';
import { SupplierHistorieDialogComponent } from './supplier-historie-dialog/supplier-historie-dialog.component';
import { SupplierMaterial } from './supplier-material';

@Component({
    selector: 'kiene-supplier-material',
    templateUrl: './supplier-material.component.html',
    styleUrls: ['./supplier-material.component.scss'],
})
export class SupplierMaterialComponent implements OnInit, OnChanges {
    @Input('material') material: Material;
    @Input('disabled') disabled = false;
    @Output('change') change = new EventEmitter<boolean>();
    @Output('currentStandardSupplierMaterial') currentStandardSupplierMaterial = new EventEmitter<SupplierMaterial>();

    supplierMaterials: SupplierMaterial[] = [];
    isAdmin: boolean;

    constructor(
        private readonly api: KieneTableService,
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly notification: MessageService,
        protected localStorageService: LocalStorageService,
    ) {}

    ngOnInit() {
        this.isAdmin = this.localStorageService.currentUserIsAdmin();
    }

    ngOnChanges() {
        this.loadSupplierMaterials();
    }

    loadSupplierMaterials() {
        if (!this.localStorageService.currentUserHasPermission(1091)) {
            return;
        }
        if (this.material && this.material.artikel_id) {
            let params = new HttpParams().set('artikel_id', this.material.artikel_id.toString());
            this.api.get(this.apiBaseUrl + 'artikel_lieferant/read.php', params).subscribe(
                response => {
                    this.supplierMaterials = response.records;
                    this.emitCurrentStandardSupplierMaterial();
                },
                () => {},
            );
        }
    }

    emitCurrentStandardSupplierMaterial() {
        for (let sm of this.supplierMaterials) {
            if (KieneUtils.isApiOne(sm.standard_lieferant)) {
                this.currentStandardSupplierMaterial.emit(sm);
            }
        }
    }

    openDeleteDialog(sm: SupplierMaterial) {
        let dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '33%',
            minWidth: '330px',
            data: {
                title: 'Lieferant von Artikel entfernen',
                text: 'Wollen Sie Lieferant ' + sm.lieferant + ' von Artikel ' + sm.artikel + ' entfernen?',
                textButton: 'Lieferant entfernen',
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.api.deleteEntity(this.apiBaseUrl + 'artikel_lieferant/delete.php', sm).subscribe(
                    () => {
                        this.notification.infoMessage('Lieferant erfolgreich entfernt!');
                        this.loadSupplierMaterials();
                    },
                    error => {
                        this.notification.errorMessage('Fehler beim Entfernen des Lieferanten aufgetreten!', error);
                    },
                );
            }
        });
    }

    openHistorieDialog(sm: SupplierMaterial) {
        this.dialog.open(SupplierHistorieDialogComponent, { data: sm, minWidth: '90%' });
    }

    openDetailsDialog(sm?: SupplierMaterial) {
        let create = sm ? false : true;

        let dialogRef = this.dialog.open(AddSupplierMaterialComponent, {
            width: '50%',
            minWidth: '300px',
            data: { create: sm ? false : true, material: this.material, supplierMaterial: sm },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                console.log('result', result);
                if (create) {
                    this.api.updateEntity(this.apiBaseUrl + 'artikel_lieferant/update.php', result).subscribe(
                        () => {
                            this.notification.infoMessage('Lieferant erfolgreich hinzugefügt!');
                            this.loadSupplierMaterials();
                            this.change.emit(true);
                        },
                        error => {
                            this.notification.errorMessage('Fehler beim Lieferant hinzufügen aufgetreten!', error);
                            this.loadSupplierMaterials();
                        },
                    );
                } else {
                    this.api.updateEntity(this.apiBaseUrl + 'artikel_lieferant/update.php', result).subscribe(
                        response => {
                            console.log(response, result);
                            this.notification.infoMessage('Lieferant erfolgreich editiert!');
                            this.loadSupplierMaterials();
                            this.change.emit(true);
                        },
                        error => {
                            this.notification.errorMessage('Fehler beim Lieferant editieren aufgetreten!', error);
                            this.loadSupplierMaterials();
                        },
                    );
                }
            }
        });
    }

    gibRabattiertenPreis(sm: SupplierMaterial) {
        if (sm.rabatt !== null && sm.rabatt !== undefined && sm.rabatt > 0) {
            return (sm.einzelpreis * (100 - sm.rabatt)) / 100;
        }
        return sm.einzelpreis;
    }
}
